export default "__VITE_ASSET__B3H_$ZyI__"